<div class="grid-container" [formGroup]="formGroup">
  <!-- Legal Name -->
  <mat-form-field
    appearance="outline"
    [ngClass]="{ 'mat-form-field-readonly': readonly }"
  >
    <mat-label [ngClass]="{ 'label-text-readonly': readonly }">{{
      "legal-name" | translate
    }}</mat-label>
    <input
      matInput
      type="text"
      formControlName="legalName"
      [required]="required"
    />
    <mat-error
      *ngIf="
        formGroup.get('legalName')?.invalid &&
        formGroup.get('legalName')?.touched &&
        !readonly
      "
    >
      {{ "required-legal-name" | translate }}
    </mat-error>
  </mat-form-field>

  <!-- Fiscal Address -->
  <mat-form-field
    appearance="outline"
    [ngClass]="{ 'mat-form-field-readonly': readonly }"
  >
    <mat-label [ngClass]="{ 'label-text-readonly': readonly }">{{
      "fiscal-address" | translate
    }}</mat-label>
    <input
      matInput
      type="text"
      formControlName="fiscalAddress"
      [required]="required"
    />
    <mat-error
      *ngIf="
        formGroup.get('fiscalAddress')?.invalid &&
        formGroup.get('fiscalAddress')?.touched &&
        !readonly
      "
    >
      {{ "required-fiscal-address" | translate }}
    </mat-error>
  </mat-form-field>

  <!-- Iva Code -->
  <mat-form-field
    appearance="outline"
    [ngClass]="{ 'mat-form-field-readonly': readonly }"
  >
    <mat-label [ngClass]="{ 'label-text-readonly': readonly }">{{
      "iva-code" | translate
    }}</mat-label>
    <input
      matInput
      type="text"
      formControlName="ivaCode"
      [required]="required"
      style="text-transform: uppercase"
      (input)="toUppercase($event)"
    />
    <mat-error
      *ngIf="
        formGroup.get('ivaCode')?.invalid &&
        formGroup.get('ivaCode')?.touched &&
        !readonly
      "
    >
      {{ "required-iva-code" | translate }}
    </mat-error>
  </mat-form-field>

  <!-- Advance Purchase Days (for the hotel is not needed) -->
  <mat-form-field
    *ngIf="advancedPurchaseDaysRequired"
    appearance="outline"
    [ngClass]="{ 'mat-form-field-readonly': readonly }"
  >
    <mat-label [ngClass]="{ 'label-text-readonly': readonly }">{{
      "advance-purchase-days" | translate
    }}</mat-label>
    <input
      matInput
      type="number"
      formControlName="advancePurchaseDays"
      [required]="required"
    />
    <mat-error
      *ngIf="
        formGroup.get('advancePurchaseDays')?.invalid &&
        formGroup.get('advancePurchaseDays')?.touched &&
        !readonly
      "
    >
      {{ "required-advance-purchase-days" | translate }}
    </mat-error>
  </mat-form-field>
</div>
